export default __webpack_public_path__ + "static/green-dots-blob-3-b7345a4b42bc287072e35bb97f129d91.svg";